import type { OpportunitiesFilters } from "../components/table/OpportunitiesTableToolbar/OpportunitiesTableToolbar";

export const OPPORTUNITY_FILTER_ALL = "all" as const;

/** Primary dataset flow — preselected on first load and on new-set creation. */
export const DEFAULT_OPPORTUNITY_FLOW_NAME = "Angles" as const;

/** Baseline used by "Clear filters" and by `hasActiveOpportunityFilters`. Every key is `all`
 *  so the preselected Angles flow surfaces a visible "Clear filters" affordance. */
export const DEFAULT_OPPORTUNITY_FILTERS: OpportunitiesFilters = {
  action: OPPORTUNITY_FILTER_ALL,
  flowName: OPPORTUNITY_FILTER_ALL,
  feature: OPPORTUNITY_FILTER_ALL,
  subFeature: OPPORTUNITY_FILTER_ALL,
  engine: OPPORTUNITY_FILTER_ALL,
};

/** Filters preselected on first navigation to the page and on set-switch — points the user at
 *  the primary Angles workflow without locking them in (Clear filters → DEFAULT_OPPORTUNITY_FILTERS). */
export const INITIAL_OPPORTUNITY_FILTERS: OpportunitiesFilters = {
  ...DEFAULT_OPPORTUNITY_FILTERS,
  flowName: DEFAULT_OPPORTUNITY_FLOW_NAME,
};

export function isDefaultOpportunityFilter(
  key: keyof OpportunitiesFilters,
  value: string,
): boolean {
  return value === DEFAULT_OPPORTUNITY_FILTERS[key];
}

export function hasActiveOpportunityFilters(
  filters: OpportunitiesFilters,
  search = "",
): boolean {
  if (search.trim() !== "") return true;
  return (Object.keys(filters) as (keyof OpportunitiesFilters)[]).some(
    (key) => !isDefaultOpportunityFilter(key, filters[key]),
  );
}

export function countActiveOpportunityFilters(filters: OpportunitiesFilters): number {
  return (Object.keys(filters) as (keyof OpportunitiesFilters)[]).filter(
    (key) => !isDefaultOpportunityFilter(key, filters[key]),
  ).length;
}
